import React from 'react';
import { gsm7bitExRegExp, gsm7bitRegExp } from '../../utils/Helpers';
import CharacterSpan from './CharacterSpan';

interface MessageAnalyzerProps {
    smsCharacters: string[];
}

const MessageAnalyzer: React.FC<MessageAnalyzerProps> = ({ smsCharacters }) => {
    return (
        <React.Fragment>
            <h2 className='text-base pb-2 text-gray-600 font-semibold tracking-wide uppercase'>Message Analyzer</h2>
            <div className='shadow p-2.5 sm:p-3.5 rounded-md block border char-container'>
                {smsCharacters.length === 0 && (
                    <div className='flex'>
                        <span className='m-auto mt-2.5 text-gray-400 font-medium text-xs'>Message characters will appear here</span>
                    </div>
                )}
                {smsCharacters.map((char, idx) => {
                    if (char.match(gsm7bitRegExp)) {
                        return <CharacterSpan key={idx} type='GSM' character={char} />;
                    } else if (char.match(gsm7bitExRegExp)) {
                        return <CharacterSpan key={idx} type='NOTGSM' character={char} />;
                    } else {
                        return <CharacterSpan key={idx} type='UNICODE' character={char} />;
                    }
                })}
            </div>
            <div className='shadow mt-2 p-4 grid grid-flow-row grid-cols-auto sm:grid-cols-3 gap-4 text-sm border'>
                <div className='flex items-center'>
                    <span className='w-8 h-8 bg-gray-300 flex-shrink-0'></span>
                    <span className='ml-3 text-gray-500 font-medium'>Regular 7-bit character, present in GSM charset</span>
                </div>
                <div className='flex items-center'>
                    <span className='w-8 h-8 bg-yellow-400 flex-shrink-0'></span>
                    <span className='ml-3 text-gray-500 font-medium'>Symbol in GSM charset that is counted as 2 characters.</span>
                </div>
                <div className='flex items-center'>
                    <span className='w-8 h-8 bg-red-400 flex-shrink-0'></span>
                    <span className='ml-3 text-gray-500 font-medium'>
                        Character not present in GSM charset, forces to use Unicode encoding
                    </span>
                </div>
            </div>
        </React.Fragment>
    );
};

export default MessageAnalyzer;
